module.exports = __webpack_public_path__ + "img/bluefire-header-img.57d68c93.jpg";